import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M9 6h6a6 6 0 0 1 6 6v5a1 1 0 0 1 -1 1h-16a1 1 0 0 1 -1 -1v-5a6 6 0 0 1 6 -6","key":"svg-0"}]]

const IconRectangleRoundedTop = createReactComponent('outline', 'rectangle-rounded-top', 'RectangleRoundedTop', __iconNode);

export default IconRectangleRoundedTop;